module.exports = __webpack_public_path__ + "img/IR.5a561761.svg";